import _defineProperty from "/usr/src/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/usr/src/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["className"],
  _excluded2 = ["className", "children"],
  _excluded3 = ["className", "popupClassName"];
var __jsx = React.createElement;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Menu } from 'antd';
import classNames from 'classnames';
import DixuText from "../DixuText/DixuText";
import React from 'react';
const DixuMenu = _ref => {
  let {
      className
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded);
  const classes = classNames('dixu-menu', className);
  return /*#__PURE__*/React.createElement(Menu, _objectSpread({
    className: classes
  }, rest));
};
const DixuMenuItem = _ref2 => {
  let {
      className,
      children
    } = _ref2,
    rest = _objectWithoutProperties(_ref2, _excluded2);
  const classes = classNames('dixu-menu-item', className);
  return /*#__PURE__*/React.createElement(Menu.Item, _objectSpread({
    className: classes
  }, rest), /*#__PURE__*/React.createElement(DixuText, {
    font: "3",
    color: "2-8",
    weight: "medium"
  }, children));
};
DixuMenu.Item = DixuMenuItem;
const DixuSubMenu = _ref3 => {
  let {
      className,
      popupClassName
    } = _ref3,
    rest = _objectWithoutProperties(_ref3, _excluded3);
  const classes = classNames('dixu-sub-menu', className);
  const popupClasses = classNames('dixu-sub-menu-popup', popupClassName);
  return /*#__PURE__*/React.createElement(Menu.SubMenu, _objectSpread({
    className: classes,
    popupClassName: popupClasses
  }, rest));
};
DixuMenu.SubMenu = DixuSubMenu;
export default DixuMenu;